import { useState } from 'react';

/** Fetches the file and triggers a browser download, tracking the in-flight state. */
const useDownloadFile = (url: string, filename?: string) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadFile = async () => {
    if (!url || isDownloading) {
      return;
    }

    setIsDownloading(true);
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to download document. Status: ${response.status}`);
      }

      const blob = await response.blob();
      const blobURL = URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = blobURL;
      anchor.style.display = 'none';
      anchor.download = filename?.length ? filename : 'document';
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
      setTimeout(() => URL.revokeObjectURL(blobURL), 0);
    } catch (error) {
      console.error(error);
    } finally {
      setIsDownloading(false);
    }
  };

  return { isDownloading, downloadFile };
};

export default useDownloadFile;
